import { Box, Flex, Text, Divider, Skeleton } from "@chakra-ui/react";
import { MdTrendingUp, MdTrendingDown } from "react-icons/md";
import { PieChart, Pie, Cell } from "recharts";
import colors from "core/resources/theme/colors";
import { useReceitaDespesaResultado } from "core/features/dashboards/hooks/useReceitaDespesaResultado";
import { useDashboardPrincipal } from "core/features/dashboards/store";
import { formatMoney } from "infra/helpers/number";
import { useWindowSize } from "infra/helpers/window";
import { Row, Col } from "antd";

function CardReceitaDespesaResultado() {
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useReceitaDespesaResultado(query);
  const window = useWindowSize();

  const isMobile = window.width <= 992;

  return (
    <Box
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      bg="white"
      rounded="16px"
      justifyContent="center"
      alignItems="center"
      p="24px"
      mt="16px"
    >
      <Flex mb={4}>
        <Text color="gray.700" fontSize="20px">
          Receita x Despesa x Resultado
        </Text>
      </Flex>
      <Row gutter={32}>
        <Col xs={24} md={10}>
          {!isFetching ? (
            <PieChart
              style={{
                background: colors.blue100,
                margin: isMobile ? "auto" : "0px",
                borderRadius: "50%",
              }}
              width={180}
              height={180}
            >
              <Pie
                data={[
                  { value: data?.receita ?? 0 },
                  { value: data?.despesa ?? 0 },
                ]}
                innerRadius={40}
                outerRadius={80}
                dataKey="value"
              >
                <Cell key={`cell-0`} fill={colors.blue400} />
                <Cell key={`cell-1`} fill={colors.red} />
                <Cell key={`cell-1`} fill={colors.green} />
              </Pie>
            </PieChart>
          ) : null}

          {isFetching ? (
            <Box w="180px">
              <Skeleton rounded="full" w="180px" h="180px" />
            </Box>
          ) : null}
        </Col>

        <Col xs={24} md={14}>
          <Flex
            flexDir="column"
            mt={isMobile ? 10 : 0}
            pl={isMobile ? 0 : "30px"}
            w="100%"
          >
            <Flex alignItems="center" mb="24px">
              <Flex
                w="39px"
                h="39px"
                rounded="50%"
                justifyContent="center"
                alignItems="center"
                bg={colors.blue100}
              >
                {!isFetching ? (
                  <MdTrendingUp fontSize="24px" color={colors.blue500} />
                ) : null}
                {isFetching ? (
                  <Skeleton rounded="full" w="39px" h="39px" />
                ) : null}
              </Flex>
              <Text color="gray.500" fontSize="16px" fontWeight="400" ml="24px">
                {!isFetching ? "Receita" : null}
                {isFetching ? <Skeleton w="85px" h="30px" /> : null}
              </Text>
              <Text color="gray.600" fontSize="18px" fontWeight="600" ml="auto">
                {!isFetching ? formatMoney(data?.receita ?? 0) : null}
                {isFetching ? <Skeleton w="70px" h="30px" /> : null}
              </Text>
            </Flex>
            <Flex alignItems="center">
              <Flex
                w="39px"
                h="39px"
                rounded="50%"
                justifyContent="center"
                alignItems="center"
                bg={colors.red100}
              >
                {!isFetching ? (
                  <MdTrendingDown fontSize="24px" color={colors.red} />
                ) : null}
                {isFetching ? (
                  <Skeleton rounded="full" w="39px" h="39px" />
                ) : null}
              </Flex>
              <Text color="gray.500" fontSize="16px" fontWeight="400" ml="24px">
                {!isFetching ? "Despesas" : null}
                {isFetching ? <Skeleton w="85px" h="30px" /> : null}
              </Text>
              <Text color="gray.600" fontSize="18px" fontWeight="600" ml="auto">
                {!isFetching ? formatMoney(data?.despesa ?? 0) : null}
                {isFetching ? <Skeleton w="70px" h="30px" /> : null}
              </Text>
            </Flex>
            <Divider mt="16px" />
            <Flex alignItems="center" mt="16px">
              <Text color="gray.500" fontSize="16px" fontWeight="400" ml="63px">
                {!isFetching ? "Resultado" : null}
                {isFetching ? <Skeleton w="85px" h="30px" /> : null}
              </Text>
              <Text
                fontSize="18px"
                fontWeight="600"
                ml="auto"
                color={
                  !data?.resultado
                    ? colors.black700
                    : data?.resultado! > 0
                    ? colors.blue500
                    : colors.red
                }
              >
                {!isFetching ? formatMoney(data?.resultado ?? 0) : null}
                {isFetching ? <Skeleton w="70px" h="30px" /> : null}
              </Text>
            </Flex>
          </Flex>
        </Col>
      </Row>
    </Box>
  );
}

export default CardReceitaDespesaResultado;
